export const PERFORMANCEAPPRAISAL_LOADING = "PERFORMANCEAPPRAISAL_LOADING";
export const PERFORMANCEAPPRAISAL_RESET = "PERFORMANCEAPPRAISAL_RESET";
export const GET_PERFORMANCEAPPRAISAL = "GET_PERFORMANCEAPPRAISAL";
export const GET_PERFORMANCEAPPRAISAL_SUCCESS = "GET_PERFORMANCEAPPRAISAL_SUCCESS";
export const GET_PERFORMANCEAPPRAISAL_FAIL = "GET_PERFORMANCEAPPRAISAL_FAIL";
export const DELETE_PERFORMANCEAPPRAISAL = "DELETE_PERFORMANCEAPPRAISAL"
export const DELETE_PERFORMANCEAPPRAISAL_SUCCESS = "DELETE_PERFORMANCEAPPRAISAL_SUCCESS"
export const DELETE_PERFORMANCEAPPRAISAL_FAIL = "DELETE_PERFORMANCEAPPRAISAL_FAIL"
export const UPDATE_PERFORMANCEAPPRAISAL = "UPDATE_PERFORMANCEAPPRAISAL"
export const UPDATE_PERFORMANCEAPPRAISAL_SUCCESS = "UPDATE_PERFORMANCEAPPRAISAL_SUCCESS"
export const UPDATE_PERFORMANCEAPPRAISAL_FAIL = "UPDATE_PERFORMANCEAPPRAISAL_FAIL"
export const ADD_NEW_PERFORMANCEAPPRAISAL = "ADD_NEW_PERFORMANCEAPPRAISAL"
export const ADD_PERFORMANCEAPPRAISAL_SUCCESS = "ADD_PERFORMANCEAPPRAISAL_SUCCESS"
export const ADD_PERFORMANCEAPPRAISAL_FAIL = "ADD_PERFORMANCEAPPRAISAL_FAIL"